import React, { useCallback, useEffect, useState } from "react";
import {
  StyledBox,
  StyledButton,
  StyledContainer,
  StyledInput,
  StyledRoot,
} from "./auth.styled";
import { Box, Link, Typography } from "@mui/material";
import { MdOutlineEmail, MdOutlineLock } from "react-icons/md";
import { RegisterUserParams } from "../../../api/auth-request";
import { useCreateUser } from "../../../api-hooks/use-create-user";
import { toast } from "sonner";
import { AiOutlineUser } from "react-icons/ai";

type RegisterProps = {
  handleLogin: () => void;
};

const Register: React.FC<RegisterProps> = ({ handleLogin }) => {
  const [user, setUser] = useState<
    RegisterUserParams & { confirmPassword: string }
  >({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const { mutate, isPending, isSuccess } = useCreateUser();

  const handleDataChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setUser((prev) => {
        return { ...prev, [event.target.name]: event.target.value };
      });
    },
    [],
  );

  const handleSignUp = useCallback(() => {
    if (user.password !== user.confirmPassword) {
      toast.error("Passwords doesn't match");
      return;
    }
    if (!isPending) mutate(user);
  }, [isPending, mutate, user]);

  useEffect(() => {
    if (isSuccess) handleLogin();
  }, [handleLogin, isSuccess]);

  return (
    <StyledContainer>
      <StyledRoot>
        <Typography fontWeight="bold" variant="h5">
          Create an account
        </Typography>
        <Box sx={{ marginTop: "0.5rem" }}>
          <Typography component="span">Already have an account?</Typography>
          <Link
            sx={{ cursor: "pointer", marginLeft: "0.3rem" }}
            onClick={handleLogin}
          >
            Login
          </Link>
        </Box>
        <Box sx={{ display: "flex", width: "100%", columnGap: "5px" }}>
          <StyledBox>
            <StyledInput
              name="firstName"
              placeholder="First Name"
              onChange={handleDataChange}
            />
          </StyledBox>
          <StyledBox>
            <StyledInput
              name="lastName"
              placeholder="Last Name"
              onChange={handleDataChange}
            />
          </StyledBox>
        </Box>
        <StyledBox>
          <AiOutlineUser />
          <StyledInput
            name="username"
            placeholder="Username"
            onChange={handleDataChange}
          />
        </StyledBox>
        <StyledBox>
          <MdOutlineEmail />
          <StyledInput
            name="email"
            placeholder="Email"
            type="email"
            onChange={handleDataChange}
          />
        </StyledBox>
        <StyledBox>
          <MdOutlineLock />
          <StyledInput
            name="password"
            placeholder="Password"
            type="password"
            onChange={handleDataChange}
          />
        </StyledBox>
        <StyledBox>
          <MdOutlineLock />
          <StyledInput
            name="confirmPassword"
            placeholder="Confirm Password"
            type="password"
            onChange={handleDataChange}
          />
        </StyledBox>
        <StyledButton onClick={handleSignUp}>Sign Up</StyledButton>
      </StyledRoot>
    </StyledContainer>
  );
};

export default Register;
